import React from 'react';

const Documentation = ({ docPath }) => (
  <iframe src={docPath} style={{ width: '100%', height: '100%', border: 'none' }} title="Documentation"></iframe>
);

export default Documentation;
